import { USER_ROLES } from '../../../../../../types/user'

export enum NewUserFormFields {
	NEW_USER_PREFIX = 'user_prefix',
	NEW_USER_FIRST_NAME = 'user_first_name',
	NEW_USER_SECOND_NAME = 'user_second_nome',
	NEW_USER_EMAIL = 'user_email',
	NEW_USER_PHONE = 'user_phone',
	NEW_USER_DATE_BIRTH = 'user_date_birth',
	NEW_USER_GENDER_BIRTH = 'user_gender_birth',
	NEW_USER_ADDRESS_1 = 'user_address_1',
	NEW_USER_ADDRESS_2 = 'user_address_2',
	NEW_USER_COUNTRY = 'user_country',
	NEW_USER_CITY = 'user_city',
	NEW_USER_STATE = 'user_state',
	NEW_USER_ZIP = 'user_zip',
	NEW_USER_ORGANIZATION = 'user_organization',
	NEW_USER_ROLE = 'user_role',
	NEW_USER_BIO = 'user_bio',
	NEW_USER_DATE_STARTED = 'user_date_started',
	NEW_USER_ACCOUNTS = 'user_accounts',
	NEW_USER_EXPERTISE = 'user_expertise',
	NEW_USER_NOTES = 'user_notes',
	NEW_USER_TIRE = 'user_tire',
	NEW_USER_SKILLS = 'user_skills',
	NEW_USER_CARBS = 'user_carbs',
	NEW_USER_DATE_CONFIG = 'user_dateConfig',
	NEW_USER_GLUCOSE = 'user_glucoseLevel',
	NEW_USER_LANG = 'user_language',
	NEW_USER_TEMP = 'user_temperature',
	NEW_USER_UNITS = 'user_weightHeight',
}

export interface NewUserFormPersonal {
	[NewUserFormFields.NEW_USER_PREFIX]: string
	[NewUserFormFields.NEW_USER_FIRST_NAME]: string
	[NewUserFormFields.NEW_USER_SECOND_NAME]: string
	[NewUserFormFields.NEW_USER_EMAIL]: string
	[NewUserFormFields.NEW_USER_PHONE]: string
	[NewUserFormFields.NEW_USER_DATE_BIRTH]: string
	[NewUserFormFields.NEW_USER_GENDER_BIRTH]: string
	[NewUserFormFields.NEW_USER_ADDRESS_1]: string
	[NewUserFormFields.NEW_USER_ADDRESS_2]: string
	[NewUserFormFields.NEW_USER_COUNTRY]: string
	[NewUserFormFields.NEW_USER_CITY]: string
	[NewUserFormFields.NEW_USER_STATE]: string
	[NewUserFormFields.NEW_USER_ZIP]: string
}

export interface NewUserFormEmployments {
	[NewUserFormFields.NEW_USER_ORGANIZATION]: string
	[NewUserFormFields.NEW_USER_ROLE]: Array<USER_ROLES>
	[NewUserFormFields.NEW_USER_BIO]: string
	[NewUserFormFields.NEW_USER_DATE_STARTED]: string | null
	[NewUserFormFields.NEW_USER_ACCOUNTS]: Array<string>
	[NewUserFormFields.NEW_USER_EXPERTISE]: Array<string>
	[NewUserFormFields.NEW_USER_NOTES]: string
	[NewUserFormFields.NEW_USER_TIRE]: Array<string>
	[NewUserFormFields.NEW_USER_SKILLS]: Array<string>
}

export interface NewUserFormLocalization {
	[NewUserFormFields.NEW_USER_UNITS]: string
	[NewUserFormFields.NEW_USER_TEMP]: string
	[NewUserFormFields.NEW_USER_LANG]: string
	[NewUserFormFields.NEW_USER_GLUCOSE]: string
	[NewUserFormFields.NEW_USER_DATE_CONFIG]: string
	[NewUserFormFields.NEW_USER_CARBS]: string
}

export interface NewUserFormPermission {}

export interface NewUserForm
	extends NewUserFormLocalization,
		NewUserFormEmployments,
		NewUserFormPersonal {}
